var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgContracts = function SvgContracts(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: 18.666,
    height: 20,
    viewBox: "0 0 18.666 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-422.337 -524.171)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.337 524.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M436.594,541.031H422.337v-16.86h14.257Zm-13.562-.7H435.9v-15.47H423.032Z",
    transform: "translate(-422.337 -524.171)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(423.406 525.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 13.562,
    height: 16.165,
    transform: "translate(0.347 0.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M438.132,542.569H423.875v-16.86h14.257Zm-13.562-.7h12.866V526.4H424.57Z",
    transform: "translate(-423.875 -525.709)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(425.56 527.776)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9.681,
    height: 0.695,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(425.56 530.016)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9.681,
    height: 0.695
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(425.56 532.255)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9.681,
    height: 0.695
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(425.56 534.494)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9.681,
    height: 0.695
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(425.56 536.733)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 9.681,
    height: 0.695
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(425.56 538.972)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 3.392,
    height: 0.695
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(431.301 534.468)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.851,0A4.851,4.851,0,1,1,0,4.851,4.851,4.851,0,0,1,4.851,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M443.382,545.582c0,.783-.514,1.5-1.748,1.606l-.007.823h-.676l.006-.838a2.656,2.656,0,0,1-1.747-.823l.459-.622a2.311,2.311,0,0,0,1.289.708,1.989,1.989,0,0,0,.411.047c.095,0,.182-.006.263-.013.676-.081.918-.472.918-.816,0-.46-.4-.649-.918-.8-.122-.034-.25-.068-.385-.108-.094-.02-.189-.047-.29-.074-.784-.216-1.579-.519-1.579-1.5a1.381,1.381,0,0,1,.438-1.019,2.022,2.022,0,0,1,1.147-.5v-.938h.676v.945a2.578,2.578,0,0,1,1.62.722l-.472.6a2.039,2.039,0,0,0-1.147-.6,2.163,2.163,0,0,0-.419-.04,1.582,1.582,0,0,0-.256.027.781.781,0,0,0-.749.735c0,.357.31.533.749.676.156.047.325.088.506.135.054.014.108.034.169.047C442.477,544.2,443.382,544.5,443.382,545.582Z",
    transform: "translate(-436.445 -539.512)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContracts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Contracts.370c8eca.svg";
export { ForwardRef as ReactComponent };